/**
 * @module @mkt-common/shopee-common
 */
/** All CIDs (in lowercase) */
var CIDs;
(function (CIDs) {
    /** 印尼 */
    CIDs["id"] = "id";
    /** 马来西亚 */
    CIDs["my"] = "my";
    /** 菲律宾 */
    CIDs["ph"] = "ph";
    /** 新加坡 */
    CIDs["sg"] = "sg";
    /** 泰国 */
    CIDs["th"] = "th";
    /** 台湾 */
    CIDs["tw"] = "tw";
    /** 越南 */
    CIDs["vn"] = "vn";
    /** 巴西 */
    CIDs["br"] = "br";
    /** 墨西哥 */
    CIDs["mx"] = "mx";
    /** 哥伦比亚 */
    CIDs["co"] = "co";
    /** 智利 */
    CIDs["cl"] = "cl";
    /** 线上压测环境 */
    CIDs["xx"] = "xx";
})(CIDs || (CIDs = {}));
let cid = CIDs.sg;
if (typeof COUNTRY !== 'undefined') {
    cid = COUNTRY;
}
else if (typeof REGION !== 'undefined') {
    cid = REGION;
}
else if (typeof process !== 'undefined' && typeof process.env === 'object' && process.env.country) {
    cid = process.env.country;
}
else if (typeof process !== 'undefined' && typeof process.env === 'object' && process.env.cid) {
    // jenkins 部署时候使用 cid 来传入给对应执行的命令
    cid = process.env.cid;
}
let shopeeEnvironment = 'live';
if (typeof ENVIRONMENT !== 'undefined') {
    shopeeEnvironment = ENVIRONMENT;
}
else if (typeof process !== 'undefined' && typeof process.env === 'object' && process.env.environment) {
    shopeeEnvironment = process.env.environment;
}
/** @deprecated
 * 请使用 `cid` 替换
 */
const country = cid;
const getCidAtRuntime = () => window.REGION || window.COUNTRY;
const getEnvAtRuntime = () => window.ENVIRONMENT;

export { CIDs, cid, country, getCidAtRuntime, getEnvAtRuntime, shopeeEnvironment };
